import { DocumentTextIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedPoliceReportCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface PoliceReportCreatedEventProps {
  event: DiscriminatedPoliceReportCreatedEvent;
}

export const PoliceReportCreatedEvent: React.FC<
  PoliceReportCreatedEventProps
> = ({ event }) => {
  const { police_report } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-amber-100">
          <DocumentTextIcon className="h-4 w-4 text-amber-600" />
        </div>
      }
    />
  );

  const departmentName = police_report?.police_department?.name;
  const reportIdentifier = police_report?.report_identifier;
  const reportedIncidentDate = police_report?.reported_incident_date;
  const reportedLocation = police_report?.reported_location;

  const body = (
    <ActivityBody>
      <div className="space-y-1">
        {departmentName && <ActivityTitle>{departmentName}</ActivityTitle>}
        {reportIdentifier && (
          <ActivityDescription>Report: {reportIdentifier}</ActivityDescription>
        )}
        {reportedIncidentDate && (
          <ActivityDescription>
            Incident Date: {new Date(reportedIncidentDate).toLocaleDateString()}
          </ActivityDescription>
        )}
        {reportedLocation && (
          <ActivityDescription>
            Location: {reportedLocation}
          </ActivityDescription>
        )}
      </div>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Police Report Added"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
